import React from "react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import type { SidebarNavItem } from "./sidebarNavItems";

interface SidebarItemProps {
  item: SidebarNavItem;
  isActive: boolean;
  isOpen: boolean;
  onClick: () => void;
}

export const SidebarItem = React.memo(
  ({ item, isActive, isOpen, onClick }: SidebarItemProps) => {
    const Icon = item.icon;
    const { t } = useTranslation("common");

    return (
      <button
        onClick={onClick}
        className={cn(
          "flex flex-col items-center gap-[0.25rem] py-[0.75rem] w-full transition-colors",
          isActive
            ? "text-[var(--primary-blue)]"
            : "text-gray-600 hover:bg-gray-50",
          item.disabled && "text-gray-600 hover:cursor-not-allowed blur-[1px]",
        )}
      >
        <div
          className={
            isActive
              ? "bg-[var(--hover-blue)] px-6 py-[0.27rem] rounded-3xl"
              : "px-6 py-[0.27rem]"
          }
        >
          <Icon />
        </div>

        {isOpen && (
          <span
            className={`text-sidebar-menu ${
              isActive ? "text-[var(--primary-blue)]" : ""
            }`}
          >
            {t(item.label)}
          </span>
        )}
      </button>
    );
  },
);
